export function buildResearchDefenderPayload(
  object,
  text,
  c_text,
  t_page_load,
  t_text_typed,
  t_submit
) {
  const { input_id: q_id, survey_id: sy_nr, visa: sn_ud } = object;
  return JSON.stringify({
    q_id,
    text,
    c_text,
    t_page_load,
    t_text_typed,
    t_submit,
    sn_ud,
    sy_nr,
  });
}

export function getDefaultPhaseRange(self) {
  return {
    min: self._object.phase_pos * self._object.displaymax,
    max:
      self._object.phase_pos * self._object.displaymax +
      self._object.displaymax -
      1,
  };
}

/**
 *
 * `displaymax` counts response options, while the elements being paged are
 * rows holding `columns` options each, so an item range only matches a row
 * range when there is a single column. The layout records which rows belong
 * to which page; prefer that, and fall back to the item range for widgets
 * that page over the response options themselves (cardsort).
 *
 * @param {object} self The widget instance.
 * @param {object} [layout] The widget's DynamicRowLayout instance.
 */
export function getPhaseRange(self, layout) {
  var ranges = layout && layout.groupRowRanges;
  if (!ranges || !ranges.length) {
    return getDefaultPhaseRange(self);
  }

  var range = ranges[self._object.phase_pos] || ranges[ranges.length - 1];
  return { min: range.start, max: range.end };
}

export function getLoadAccessibilityMenuTrigger() {
  return {
    button: {
      keydown: true,
      click: false,
    },
    menu: {
      keydown: true,
      click: true,
      mouseover: true,
    },
  };
}

export function handlePagedVisibility(elems, range) {
  _.each(elems, function (row, idx) {
    if (idx < range.min || idx > range.max) {
      $(row).hide();
    } else {
      $(row).show();
    }
  });
}

export function isRequiredSatisfied(self, context = false) {
  if (!context) context = self;
  var required = context.required === 'HARD' ? true : false;
  var soft_required = context.soft_required;
  if (required || (soft_required && !self.displaymax_soft_prompts)) {
    if (self.selected_rows_count() < self.visible_rows_count()) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}

export function resolvePagedElems(self, elems) {
  var resolved = elems || self.$el.find('.dynamic-row');
  return resolved.length === 0 ? null : resolved;
}
